module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-23.5bb681da.png";